import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { orgId } from 'utils';
import { I18N, GlobalContext } from 'commons';

const Tabs = props => {
  const { navConfig: { showNotification, showWeather }, onPaginationChange } = useContext(GlobalContext);
  const {
    activeName,
  } = props;

  const navItems = [];

  if (showNotification) {
    navItems.push({
      activeName: 'notif',
      to: `/${orgId}/notif`,
      text: 'notification.tab.general',
    });
  }

  if (showWeather) {
    navItems.push({
      activeName: 'weather',
      to: `/${orgId}/weather`,
      text: 'notification.tab.weather',
    });
  }

  // if (showEvent) {
  //   navItems.push({
  //     activeName: 'event',
  //     to: `/${orgId}/event`,
  //     text: 'notification.tab.events',
  //   });
  // }

  return (
    <div className="notification-center-tabs">
      <h1 className="h1" eb-test="ee_notificationCenter_text_title">
        <I18N>notification.title.text</I18N>
      </h1>
      <div role="navigation">
        <Nav>
          {navItems.map(item => (
            <NavItem
              eb-test={`ee_notificationCenter_nav_${item.activeName}`}
              key={`nav-${item.activeName}`}
              onClick={() => onPaginationChange(1, 25)}
            >
              <NavLink
                disabled={activeName === item.activeName}
                tag={activeName === item.activeName ? ({ ...linkProps }) => (
                  <span {...linkProps}>
                    <I18N>{item.text}</I18N>
                  </span>
                ) : ({ ...linkProps }) => (
                  <Link to={item.to} {...linkProps}>
                    <I18N>{item.text}</I18N>
                  </Link>
                )}
              />
            </NavItem>
          ))}
        </Nav>
      </div>
    </div>
  );
};

Tabs.propTypes = {
  activeName: PropTypes.string.isRequired,
};

export default Tabs;
